import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { BSMaterialResultDashboard } from "../../../../../../../../core/dto/beem-shot/BSMaterialResult/BSMaterialResultDashboard"
import { useBSMaterialResults } from "../../../../../../../../core/hooks/beem-shot/useBSMaterialResults"
import { Children } from "../../../../../../../../components/miscellianous/children"
import { BSBuildingResultContext } from "../../../../../../../../core/context/beem-shot/BSBuildingResult/BSBuildingResultContext"

export const BSBuildingDashboardContext = React.createContext<BSBuildingDashboardStore>({} as BSBuildingDashboardStore)

export function BSBuildingDashboardContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { getBSMaterialResultListDashboard } = useBSMaterialResults()

  const { bsBuildingResult } = useContext(BSBuildingResultContext)

  const [allBSMaterialResult, setAllBSMaterialResult] = useState<BSMaterialResultDashboard[] | undefined>()

  const refreshDashboardData: () => void = useCallback(() => {
    if (bsBuildingResult?.id) {
      getBSMaterialResultListDashboard(bsBuildingResult?.buildingId).then((response) => {
        const bsMaterialResults = response.filter(
          (bsMaterialResult) =>
            bsMaterialResult.re2020CarbonImpactPerSurface < -0.05 || bsMaterialResult.re2020CarbonImpactPerSurface > 0.05
        )
        setAllBSMaterialResult(bsMaterialResults)
      })
    }
  }, [getBSMaterialResultListDashboard, bsBuildingResult])

  useEffect(() => {
    refreshDashboardData()
  }, [refreshDashboardData])

  const bSBuildingDashboardStore: BSBuildingDashboardStore = useMemo(
    () => ({
      allBSMaterialResult,
      refreshDashboardData,
    }),
    [allBSMaterialResult, refreshDashboardData]
  )
  return (
    <BSBuildingDashboardContext.Provider value={bSBuildingDashboardStore}>{children}</BSBuildingDashboardContext.Provider>
  )
}

export interface BSBuildingDashboardStore {
  allBSMaterialResult: BSMaterialResultDashboard[] | undefined
  refreshDashboardData(): void
}
